














import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import ModuleView from '../components/View.vue'

import { IModule } from '../types'
import { ICourse } from '../../courses/types'

@Component({
  components: {
    ModuleView
  }
})
export default class Create extends Vue {
  data: IModule = {}
  course: ICourse = {}

  courseId: number = 0
  moduleId: number = 0

  loading = false
  adminView = false

  async mounted() {
    this.courseId = +this.$router.currentRoute.params.courseId
    this.moduleId = +this.$router.currentRoute.params.moduleId
    this.adminView = !!this.$route.query.admin

    this.loading = true
    this.course = (await axios.get(`courses/${this.courseId}`)).data
    this.data = (await axios.get(`modules/${this.moduleId}`)).data
    this.loading = false
  }
}
